export var CAPTCHA_ERROR = 'Указаны неверные символы';